<template>
  <vs-popup class="customer-user-create-popup" id="popup" title="CREATE CUSTOMER USER" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="title" name="title" rules="" v-slot="{ errors }">
                <small class="label">Title</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.title" :reduce="option => option"
                  :options="['Mr.', 'Mrs.', 'Miss']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="createForm.first_name" name="first_name" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="createForm.last_name" class="w-full" name="last_name" type="text" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createForm.email" class="w-full" name="email" type="text" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="job_title" name="job_title" rules="" v-slot="{ errors }">
                <small class="label">Job Title</small>
                <vs-input v-model="createForm.job_title" name="job_title" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="role_id" name="role_id" rules="required" v-slot="{ errors }">
                <small class="label">Role</small>
                <v-select name="role_id" label="name" :closeOnSelect="true" :reduce="option => option.id"
                  v-model="createForm.role_id" :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="site_telephone" name="site_telephone" rules="required" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code"
                  v-model="createForm.country_code_main_telephone" :reduce="option => option.isd_code"
                  :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{ option.isd_code }} - {{ option.name }} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="telephone" name="telephone" rules="required|tel|min_tel|max_tel"
                v-slot="{ errors }">
                <small class="label">Main Telephone</small>
                <vs-input v-model="createForm.main_telephone" class="w-full" name="telephone" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="country_code_secondary_telephone" name="country_code_secondary_telephone" rules=""
                v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code"
                  v-model="createForm.country_code_secondary_telephone" :reduce="option => option.isd_code"
                  :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{ option.isd_code }} - {{ option.name }} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="secondary_telephone" name="secondary_telephone" rules="tel|min_tel|max_tel"
                v-slot="{ errors }">
                <small class="label">Secondary Telephone</small>
                <vs-input v-model="createForm.secondary_telephone" class="w-full" name="secondary_telephone" type="text"
                  label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SupplierRepository = RepositoryFactory.get('supplier')
const CustomerRepository = RepositoryFactory.get('customer')
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    media: '',
    isImage: '',
    isVideo: '',
    title: '',
    nodata: false,
    isNote: '',
    note: '',
    createForm: {},
    roles: [],
    countryCodes: []
  }
}

export default {
  name: 'TrackingImagePopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup() {
      try {
        await Object.assign(this.$data, initialState())
        await this.fetchRoles()
        await this.getCountryCodes()
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateStaffUser() {
      const vue = this;
      this.$vs.loading()
      try {
        await SupplierRepository.createSupplierUser(this.createForm)
        this.showSuccessMessage('New customer user created successfully')
        await vue.$parent.refreshData()
        this.open = false;
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchRoles() {
      this.$vs.loading()
      const { data } = (await CustomerRepository.getCustomerRoles()).data
      this.roles = data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.$vs.loading()
      try {
        const { data } = (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },

  },
  async mounted() {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>.customer-user-create-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}</style>
